import { useContext, useEffect, useState } from 'react';
import { deleteUser, ProviderId } from 'firebase/auth';
import { auth } from '../utils/firebase';
import { AuthContext } from '../context/AuthContext';
import useFirestore from './useFirestore';

const getUserName = (additionalUserInfo) => {
  if (additionalUserInfo.providerId === ProviderId.GOOGLE) {
    return {
      firstName: additionalUserInfo.profile.given_name,
      lastName: additionalUserInfo.profile.family_name,
    };
  }
  if (additionalUserInfo.providerId === ProviderId.FACEBOOK) {
    return {
      firstName: additionalUserInfo.profile.first_name,
      lastName: additionalUserInfo.profile.last_name,
    };
  }
  return {
    firstName: null,
    lastName: null,
  };
};

const useCreateUser = () => {
  const { setUser, response } = useFirestore();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { logout } = useContext(AuthContext);

  useEffect(() => {
    if (!response.success && response.error) {
      setSuccess(response.success);
      deleteUser(auth.currentUser);
      setError(response.error);
      logout();
    } else if (response.success && response.error === null) {
      setSuccess(response.success);
    }
  }, [response.success, response.error]);

  const createUser = async (user, additionalUserInfo) => {
    setSuccess(false);
    setError(null);
    await setUser(
      user.uid,
      {
        ...getUserName(additionalUserInfo),
        status: 'partial',
      },
    );
  };

  return { createUser, error, success };
};

export default useCreateUser;
